//  TODO: apagar esse service
 export enum SourceName {
  dealer = 'dealer',
  mobile = 'mobile',
  agenda = 'agenda',
  fordpass = 'fordpass',
  web = 'web',
  others = 'others',
  perks = 'perks'
}

enum SourceAbbr {
  dealer = 'D',
  mobile = 'M',
  agenda = 'A',
  fordpass = 'F',
  web = 'W',
  others = 'O'
}

enum SizeScreen {
  MOBILE = 480,
  IPAD = 1024
};

export const isMobileScreen = (): boolean => window.innerWidth <= SizeScreen.MOBILE;
export const isSourceFordPass = (source: string): boolean => source === SourceName.fordpass || source === SourceAbbr.fordpass;
export const isSourcePerks = (source: string) => SourceName.perks === source;
export const isSourceWeb = (source: string) => SourceName.web === source;
export const isSourceMobile = (source: string) => SourceName.mobile === source;
